
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.8 14.9l-3.6-.5c-.1-.6-.3-1.2-.5-1.8l2.9-2.3c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.1-.3-.1L24 9.5c-.4-.5-.8-.9-1.3-1.3L24 4.8c0-.1 0-.2-.1-.3l-1.7-1c-.1-.1-.2 0-.3.1l-2.3 2.9c-.6-.3-1.2-.4-1.8-.5l-.5-3.6c0-.1-.1-.2-.2-.2h-2c-.1 0-.2.1-.2.2L14.2 6c-.6.1-1.2.3-1.8.5l-2.3-2.9c0-.1-.1-.1-.2-.1l-1.7 1c-.2.1-.2.2-.2.3l1.3 3.4c-.4.4-.8.9-1.2 1.3L4.7 8.2c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l2.9 2.3c-.2.6-.4 1.2-.5 1.8l-3.6.5c-.2 0-.3.1-.3.3v2c0 .1.1.2.2.2l3.6.5c.1.6.3 1.2.5 1.8L3.4 22c-.1.1-.1.2-.1.3l1 1.7c.1.1.2.1.3.1L8 22.8c.4.5.8.9 1.3 1.3L8 27.5c0 .1 0 .2.1.3l1.7 1c.1.1.2 0 .3-.1l2.3-2.9c.6.2 1.2.4 1.8.5l.5 3.6c0 .1.1.2.2.2h2c.1 0 .2-.1.2-.2l.5-3.6c.6-.1 1.2-.3 1.8-.5l2.3 2.9c.1.1.2.1.3.1l1.7-1c.1-.1.1-.2.1-.3l-1.3-3.4c.5-.4.9-.8 1.3-1.3l3.4 1.3c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-2.9-2.3c.2-.6.4-1.2.5-1.8l3.6-.5c.1 0 .2-.1.2-.2v-2c.2-.2.1-.3 0-.3zM16 23c-3.8 0-6.9-3.1-6.9-6.9 0-3.8 3.1-6.9 6.9-6.9 3.8 0 6.9 3.1 6.9 6.9 0 3.8-3.1 6.9-6.9 6.9z","fill":"#fff"}})])
          )
        }
      }
    